class EducationDegree {
  constructor(title) {
    this.title = title;
  }
}
export default {
  inject: ['load'],
  data() {
    return {
      confimType: '',
      educationDegreeId: null,
      searchTitle: '',
      disabelConfirm: false,
    };
  },
  methods: {
    enableAddEditFunction: function (type, id) {
      if (type == 1) {
        this.confimType = 'add';
        for (let i = 0; i < this.allEducationDegrees.length; i++) {
          if (this.allEducationDegrees[i].id == 0) {
            return;
          }
        }
        this.allEducationDegrees.push({ title: '', isEdit: true, id: 0 });
      } else if (type == 2) {
        this.confimType = 'edit';
        let temp = this.allEducationDegrees;
        for (var i = 0; i < temp.length; i++) {
          if (temp[i].id == id) {
            temp[i].isEdit = true;
          }
        }
        this.allEducationDegrees = [];
        this.allEducationDegrees = temp;
        this.getEducationDegreeFunction(id);
      }
    },
    cancelAddEditFunction: function (id) {
      this.educationDegree = new EducationDegree('');
      for (var i = 0; i < this.allEducationDegrees.length; i++) {
        if (this.allEducationDegrees[i].id == id) {
          if (id == 0) {
            this.allEducationDegrees.splice(i, 1);
          }
          this.allEducationDegrees[i].isEdit = false;
        }
      }
    },
    showConfirmDialogFunction: function () {
      if (this.confimType == 'add') {
        this.addEducationDegreeFunction();
      } else if (this.confimType == 'edit') {
        this.$refs.confirm.title = 'ویرایش مدرک تحصیلی';
        this.$refs.confirm.text = 'از ویرایش مدرک تحصیلی اطمینان دارید؟';
        this.$refs.confirm.showConfirmDialog = true;
      } else if (this.confimType == 'delete') {
        this.$refs.confirm.title = 'حذف مدرک تحصیلی';
        this.$refs.confirm.text = 'از حذف مدرک تحصیلی اطمینان دارید؟';
        this.$refs.confirm.showConfirmDialog = true;
      }
      requestAnimationFrame(() => {
        if (this.$refs.yes) {
          this.$refs.yes.$el.focus();
        }
      });
    },
    confirmDialogConfirmFunction: function () {
      if (this.confimType == 'add') {
        this.disabelConfirm = true;
        this.addEducationDegreeFunction();
      } else if (this.confimType == 'edit') {
        this.disabelConfirm = true;
        this.editEducationDegreeFunction();
      } else if (this.confimType == 'delete') {
        this.disabelConfirm = true;
        this.deleteEducationDegreeFunction();
      }
    },
    confirmDialogCancelFunction: function () {
      if (this.confimType == 'add') {
        this.$refs.confirm.showConfirmDialog = false;
        this.disabelConfirm = false;
      } else if (this.confimType == 'edit') {
        this.$refs.confirm.showConfirmDialog = false;
        this.disabelConfirm = false;
      } else if (this.confimType == 'delete') {
        this.$refs.confirm.showConfirmDialog = false;
        this.disabelConfirm = false;
      }
    },
    //delete
    showDeleteConfirmFunction: function (id) {
      this.educationDegreeId = id;
      this.confimType = 'delete';
      this.showConfirmDialogFunction();
    },
  },
};
